export default "__VITE_ASSET__5$KMm7SV__"